import React from 'react';

import { Stack } from '@/components/layout';
import type { GuardianPlayerLevelDetailPin } from '@/features/guardian-player/types';
import { createStyles } from '@/hooks';
import { colors } from '@/theme/colors';
import { LevelDetailPinRow } from './level-detail-pin-row';

type LevelDetailPinListProps = {
  pins: GuardianPlayerLevelDetailPin[];
  selectedPinId: number;
  tablet?: boolean;
  onSelectPin: (pinId: number) => void;
};

export function LevelDetailPinList({
  pins,
  selectedPinId,
  tablet = false,
  onSelectPin,
}: LevelDetailPinListProps) {
  const styles = useStyles();

  return (
    <Stack style={[styles.card, tablet ? styles.tabletCard : styles.mobileCard]}>
      {pins.map((pin, index) => {
        const selected = tablet && pin.sourceIndex === selectedPinId;
        const nextSelected = tablet && pins[index + 1]?.sourceIndex === selectedPinId;
        return (
          <LevelDetailPinRow
            key={`${pin.key}-${pin.sourceIndex}`}
            pin={pin}
            tablet={tablet}
            selected={selected}
            showDivider={index < pins.length - 1 && !selected && !nextSelected}
            onPress={() => onSelectPin(pin.sourceIndex)}
          />
        );
      })}
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  card: {
    width: '100%',
    borderRadius: scale(12),
    backgroundColor: 'rgba(255, 255, 255, 1)',
    shadowColor: '#222B45',
    shadowOpacity: 0.04,
    shadowOffset: { width: 0, height: 0 },
    shadowRadius: scale(4),
    elevation: 1,
  },
  mobileCard: {
    paddingHorizontal: scale(12),
    paddingVertical: scale(10),
    gap: scale(24),
  },
  tabletCard: {
    paddingHorizontal: scale(12),
    paddingVertical: scale(10),
    gap: scale(4),
    borderWidth: 1,
    borderColor: colors['1'],
  },
}));
